import { Typography } from "@mui/material";
import "./assets/home.css";
import { useNavigate } from "react-router-dom";
import "./assets/heroSection.css";
import Button from "../../components/button";

export default function HeroSection() {
  const navigate = useNavigate();

  const handleAnunciosClick = () => {
    console.log("Anuncios button clicked!"); // Debug log
    navigate("/anuncios");
  };

  const handleRecursosClick = () => {
    console.log("Recursos button clicked!"); // Debug log
    navigate("/recursos");
  };

  return (
    <div className="hero-section">
      <div className="hero-overlay"></div>
      {/* Layout padding applied only to content */}
      <div className="page-section container hero-content">
        <Typography variant="h1" style={{}}>
          <span style={{ color: "var(--secondary-color)" }}>2026,</span> Año<br /> de Consagración
        </Typography>

        <div className="callToAction">
          <Button
            title={"Anuncios"}
            className={"secondary-cta-btn"}
            onClick={handleAnunciosClick}
          />
          <Button
            title={"Recursos"}
            className={"secondary-cta-btn"}
            onClick={handleRecursosClick}
          />
        </div>
      </div>
    </div>
  );
}
